import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[var(--vp-ink)] text-white py-16">
      <div className="container-custom">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center">
                <MessageCircle className="w-5 h-5 text-[var(--vp-ink)]" />
              </div>
              <span className="text-xl font-semibold" style={{ fontFamily: 'var(--font-display)' }}>
                Výzva přijata
              </span>
            </div>

            <p className="text-white/70 mb-6 max-w-sm">
              Digitální hry a výzvy pro páry i nezapomenutelné rozlučky.
              Rozhybte váš vztah malými kroky každý den.
            </p>

            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/vyzva_prijata_eu/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[var(--vp-pink)] transition-colors"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>

              <span className="text-white/70 text-sm">
                Sledujte nás na Instagramu
              </span>
            </div>
          </div>

          {/* Navigace */}
          <div>
            <h3 className="font-semibold mb-4">Navigace</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('#how-it-works')} className="text-white/70 hover:text-white">
                  Jak to funguje
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('#pricing')} className="text-white/70 hover:text-white">
                  Ceník
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('#faq')} className="text-white/70 hover:text-white">
                  FAQ
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('#contact')} className="text-white/70 hover:text-white">
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          {/* Dokumenty */}
          <div>
            <h3 className="font-semibold mb-4">Dokumenty</h3>
            <ul className="space-y-3">
              <li>
                <a href="/obchodni-podminky.html" className="text-white/70 hover:text-white">
                  Obchodní podmínky
                </a>
              </li>
              <li>
                <a href="/gdpr.html" className="text-white/70 hover:text-white">
                  Ochrana osobních údajů (GDPR)
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {currentYear} Výzva přijata. Všechna práva vyhrazena.
            </p>
            <p className="text-white/50 text-sm flex items-center gap-1">
              Vytvořeno s <Heart className="w-4 h-4 text-[var(--vp-pink)]" /> v České republice
            </p>
          </div>
        </div>

        <div className="mt-8 text-center text-white/40 text-xs">
          <p>Jakub Poloch • IČO: 23393891</p>
          <p>Fráni Šrámka 2457/28, 709 00 Ostrava – Mariánské Hory</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;